import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { useDialogs } from '../../../../hooks';
import { appointmentShape } from '../../../../types';
import { getAppointmentColor } from '../../../../utils';
import Appointment from './Appointment';
import OverflowMenu from './OverflowMenu';

const DateCell = ({ appointments, dayNumber, isToday, maxVisibleAppointments }) => {
  const {
    handleOpenAppointmentDialog: onAppointmentClick,
    handleNewAppointmentClick: onCellClick,
  } = useDialogs();

  const handleAppointmentClick = (appointment) => () => onAppointmentClick(appointment);

  const handleCellClick = (e) => {
    if (e.target === e.currentTarget) onCellClick();
  };

  const dayNumberStyles = cn(
    'flex items-center justify-center text-xs rounded-full size-6 mb-1',
    isToday && 'bg-primary text-primary-foreground font-semibold'
  );

  const overflowAppointments = appointments.slice(maxVisibleAppointments);
  const visibleAppointments = appointments.slice(0, maxVisibleAppointments);

  return (
    <div
      className="flex flex-col p-1.5 transition-colors hover:bg-muted/60"
      onClick={handleCellClick}
    >
      <div className={dayNumberStyles}>{dayNumber}</div>

      <div className="flex flex-col gap-0.5">
        {visibleAppointments.map((appointment) => (
          <Appointment
            color={getAppointmentColor(appointment)}
            key={appointment.id}
            onClick={handleAppointmentClick(appointment)}
            startAt={appointment.startAt}
            title={appointment.title}
          />
        ))}

        {overflowAppointments.length > 0 && (
          <OverflowMenu
            appointments={overflowAppointments}
            onAppointmentClick={onAppointmentClick}
          />
        )}
      </div>
    </div>
  );
};

DateCell.propTypes = {
  appointments: PropTypes.arrayOf(appointmentShape).isRequired,
  dayNumber: PropTypes.number.isRequired,
  isToday: PropTypes.bool.isRequired,
  maxVisibleAppointments: PropTypes.number.isRequired,
};

export default DateCell;
